import React from "react";
export default function NoResults() {
  return (
    <div style={{ padding: 40, textAlign: "center" }}>
      <h3>No properties found</h3>
      <p>Try changing filters or location</p>
    </div>
  );
}
